import api from './index';
//
let exports = {};

//
exports.getBidEnrollList = function (data, callback) {// 获取报名列表
    api.post('/tendBid/enroll/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 报名信息
exports.getBidEnrollInfo = function (data, callback) {// 获取报名详情
    api.post('/tendBid/enroll/info/get')
    .data(data)
    .done(callback)
    .go();
};
// 报名审核
exports.updateBidEnrollResultFlag = function (data, callback) {// 更新报名结果状态
    api.post('/tendBid/enroll/resultFlag/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 获取投标列表
exports.getBidDocList = function (data, callback) {// 获取投标列表
    api.post('/tendBid/doc/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 评分 / 定标
exports.updateBidDocEvaluated = function (data, callback) {// 投标书评标
    api.post('/tendBid/doc/evaluated/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 定标
exports.updateBidDocResultFlag = function (data, callback) {// 更新投标书结果状态
    api.post('/tendBid/doc/resultFlag/update/do')
    .data(data)
    .done(callback)
    .go();
};

// 投标商务条款
exports.getBidTermList = function (data, callback) {// 获取投标书条款列表
    api.post('/tendBid/term/list/get')
    .data(data)
    .done(callback)
    .go();
};

//查询投标商品列表
exports.getBidGoodsList = function (postData, callback) {// 获取投标书商品列表
    api.post('/tendBid/goods/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询投标商品详情
exports.getBidGoods = function (postData, callback) {// 获取投标书商品
    api.post('/tendBid/goods/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询投标服务列表
exports.getBidServcList = function (postData, callback) {// 获取投标书服务列表
    api.post('/tendBid/servc/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询投标商品详情
exports.getBidServc = function (postData, callback) {// 获取投标书服务
    api.post('/tendBid/servc/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询投标商品列表(比价)
exports.getBidGoodsPagedList = function (postData, callback) {// 分页获取投标书商品列表(比价使用)
    api.post('/tendBid/goods/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};

//查询投标服务列表(比价)
exports.getBidServcPagedList = function (postData, callback) {// 分页获取投标书服务列表(比价使用)
    api.post('/tendBid/servc/paged/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取投标详情
exports.getBidDocInfo = function (data, callback) {// 获取投标详情
    api.post('/tendBid/doc/info/get')
    .data(data)
    .done(callback)
    .go();
};

// 投标商务条款
exports.getBidTermListByDocId = function (params, callback) {// 查询投标条款信息
    api.post('/tendBid/doc/term/info/get')
    .data(params)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/tendBid.js
// module id = 147
// module chunks = 0